import React, { useEffect } from 'react';
import { rubrosHistoricos } from '../../json/rubrosHistoricos';
import './rubroshistoricos.css';

const RubrosHistoricos = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container'>
            <div className='row'>
                <div>
                    <h3 className='title'>Información Histórica</h3>
                    <hr className='hr-gob' />
                </div>
                {
                    rubrosHistoricos.map((item, index) => (
                        <div key={index} className='col-md-3 col-sm-6 col-12'>
                            <div className='card_container_historicos'>
                                <div className='card_anio'>
                                    <h5>{item.anio}</h5>
                                    <h6>{item.descripcion}</h6>
                                    {
                                        item.trimestres.map((trim, index) => (
                                            <div key={index} className='card_trimestre'>
                                                <p>{trim.trimestre} <span className="badge bg-secondary">
                                                    <a href={trim.url} target="_blank">.zip</a></span>
                                                </p>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    ))
                }

                <div className="list-group">
                    <a className="list-group-item list-group-item-action flex-column align-items-start ">
                        <div className="d-flex w-100 justify-content-between">
                            <div className='museo_item'>
                                <h5  >Información Histórica Art. 22</h5>
                            </div>
                        </div>
                        <p >Con fundamento en la Ley Orgánica de la Administración Pública para el Estado de Hidalgo con fecha de publicación
                        en el Periódico Oficial el 31 de diciembre de 2016, al Reglamento Interior de la Oficialía Mayor publicado en el Periódico Oficial
                        el 27 de julio de 2017 y al Presupuesto de Egresos del Estado de Hidalgo para el ejercicio fiscal del año 2017, puede consultar la información de manera
                        concentrada bajo la figura de Secretaría de Finanzas y Administración para el ejercicio 2017 y anteriores.
                        
                        </p>
                    </a>
                </div>



            </div>
        </div>
    )
}

export default RubrosHistoricos